const NOINDEX_ROUTE_PREFIXES = [
  '/adminhub',
  '/admin',
  '/partner',
  '/events/edit',
  '/game-maker',
  '/login',
  '/signup',
  '/me',
  '/profile',
  '/friends',
  '/shop',
  '/game',
  '/explore',
  '/explore-bosna',
  '/loyalty',
  '/sova2',
  '/sova3',
  '/sova3-admin',
  '/fabrika2',
  '/memory',
  '/sidequests',
  '/vibecheck',
  '/upload-vibecheck',
];

export function shouldNoIndexRoute(pathname) {
  const path = pathname || '/';
  return NOINDEX_ROUTE_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`)
  );
}
